import styled from 'styled-components';
import { ListItem as BaseListItem } from '@pearsontechnology/aero-components';
import color from 'tinycolor2';

export const PlaceholderIcon = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background-color: ${(props) => color(props.theme['color.text.light']).setAlpha(0.1).toString()};
  opacity: 0.3;
  margin: 1px 15px 1px 1px;
  flex: none;
`;

export const PlaceholderText = styled.div`
  height: ${(props) => props.height}px;
  max-width: ${(props) => props.maxWidth}px;
  border-radius: ${(props) => (props.height / 2)}px;
  background-color: ${(props) => color(props.theme['color.text.light']).setAlpha(0.1).toString()};
  opacity: 0.3;
  flex: 1;
`;

export const ListItem = styled(BaseListItem)`
  border-bottom: 0;
`;
